import * as React from 'react'

const SvgCaretDownIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width={20} height={20} viewBox="0 0 20 20" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.375 7.5L10 12.5l-4.375-5h8.75z"
      fill="#163250"
    />
  </svg>
)

export default SvgCaretDownIcon
